export const demographicList = [
    {
        label: "Gender",
        options: [
            {
                label: "Male",
                value: "male",
                name: "gender"
            },
            {
                label: "Female",
                value: "female",
                name: "gender"
            }]
    },
    {
        label: "Age",
        options: [
            {
                label: "18+",
                value: "18+",
                name: "age"
            },
            {
                label: "15 - 17",
                value: "16-17",
                name: "age"
            },
            {
                label: "18 - 24",
                value: "18-24",
                name: "age"
            },
            {
                label: "25 - 39",
                value: "25-39",
                name: "age"
            },
            {
                label: "40 - 54",
                value: "40-54",
                name: "age"
            },
            {
                label: "55 - 64",
                value: "55-64",
                name: "age"
            },
            {
                label: "65+",
                value: "65+",
                name: "age"
            }]
    }
]
